import { jsxs as d, jsx as r, Fragment as y } from "react/jsx-runtime";
import * as u from "@radix-ui/react-checkbox";
import B from "classnames";
import { uniqueId as C } from "lodash/fp";
import { forwardRef as D, useState as O, useEffect as R, useCallback as S, cloneElement as _ } from "react";
import o from "./index.es561.js";
import { PartialIcon as q } from "./index.es562.js";
import { CheckedmarkIcon as w } from "./index.es563.js";
import { BodyText as z } from "./index.es487.js";
import { TinyText as A } from "./index.es493.js";
const H = "checkbox-component", Q = D(
  ({
    id: a = C("checkbox"),
    label: t,
    description: b,
    RightIcon: x,
    isPartial: I,
    disabled: i,
    variant: N = "gray",
    testId: n = H,
    onCheckedChange: e,
    defaultChecked: l,
    checked: s,
    required: T,
    "aria-label": E,
    ...k
  }, F) => {
    const f = s !== void 0, c = !!b, [p, m] = O(
      !!l || !!s
    ), h = `${a}-label`;
    R(() => {
      m(!!l || !!s);
    }, [s, l]);
    const $ = B(o.checkbox, {
      [o["brand-checkbox"]]: N === "brand"
    }), j = S(
      (v) => {
        f || m(v), e == null || e(a, v);
      },
      [a, f, e, m]
    );
    return /* @__PURE__ */ d("div", { className: o.root, "data-testid": n, ...k, ref: F, tabIndex: -1, children: [
      /* @__PURE__ */ r(
        u.Root,
        {
          id: a,
          disabled: i,
          checked: p,
          className: $,
          onCheckedChange: j,
          required: T,
          tabIndex: 0,
          "aria-labelledby": t ? h : void 0,
          "aria-label": t ? void 0 : E,
          children: /* @__PURE__ */ r(u.Indicator, { children: I ? /* @__PURE__ */ r(q, {}) : /* @__PURE__ */ r(w, {}) })
        }
      ),
      t && /* @__PURE__ */ d("span", { className: o.labelsContainer, children: [
        /* @__PURE__ */ d("div", { className: o.texts, "data-testid": `${n}-label`, children: [
          /* @__PURE__ */ r(
            z,
            {
              id: h,
              variant: p ? "bold" : c ? "semi-bold" : "regular",
              element: "label",
              color: i ? "disabled" : "secondary",
              htmlFor: a,
              children: t
            }
          ),
          c && x && (/* @__PURE__ */ r(y, { children: _(x, {
            size: 16,
            "data-testid": "right-icon"
          }) }) || /* @__PURE__ */ r(y, {}))
        ] }),
        c && t && /* @__PURE__ */ r("span", { className: o.texts, "data-testid": `${n}-desc`, children: /* @__PURE__ */ r(
          A,
          {
            variant: "address",
            color: i ? "disabled" : "secondary",
            children: b
          }
        ) })
      ] })
    ] });
  }
);
export {
  H as CHECKBOX_DEFAULT_TESTID,
  Q as Checkbox
};
//# sourceMappingURL=index.es25.js.map
